// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsible-card {
  position: relative;
  border: solid 1px #d4cfbe;
  margin-bottom: 20px;
}
.collapsible-card .collapsible-heading {
  display: flex;
  padding: 20px;
}
.collapsible-card .collapsible-heading .heading-text {
  flex: 1;
}
.collapsible-card .collapsible-content {
  overflow: auto;
  border-top: solid 1px #d4cfbe;
  background-color: #d4cfbe;
}
.collapsible-card .card-content-full {
  padding-bottom: 20px;
}
.collapsible-card .collapse-arrow {
  display: flex;
  align-items: center;
  width: 30px;
}
.collapsible-card .collapse-arrow .arrow {
  background-image: url('closed-chev-big.847c1b52d4b4a306.svg');
  width: 24px;
  height: 24px;
  position: absolute;
  transform: rotate(180deg);
}
.collapsible-card .collapse-arrow .arrow:hover {
  cursor: pointer;
}
.collapsible-card.collapsed .collapsible-heading .collapse-arrow .arrow {
  transform: none;
}
.collapsible-card.collapsed .collapsible-content {
  display: none;
}
.text-align-right {
  text-align: right;
}
.pull-left,
.pull-right {
  width: 50%;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/collapsible-card/collapsible-card.component.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;AADF;AAFA;EAKI,aAAA;EACA,aAAA;AAAJ;AANA;EAQM,OAAA;AACN;AATA;EAaI,cAAA;EACA,6BAAA;EACA,yBAAA;AADJ;AAdA;EAmBI,oBAAA;AAFJ;AAjBA;EAsBI,aAAA;EACA,mBAAA;EACA,WAAA;AAFJ;AAtBA;EA0BM,6DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AADN;AAGM;EACE,eAAA;AADR;AAME;EAIQ,eAAA;AAPV;AAGE;EAUI,aAAA;AAVN;AAeA;EACE,iBAAA;AAbF;AAgBA;;EACE,UAAA;AAbF","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.collapsible-card {\n  position: relative;\n  border: solid 1px @primary-50;\n  margin-bottom: 20px;\n  .collapsible-heading {\n    display: flex;\n    padding: 20px;\n    .heading-text {\n      flex: 1;\n    }\n  }\n\n  .collapsible-content {\n    overflow: auto;\n    border-top: solid 1px @primary-50;\n    background-color: @primary-50;\n  }\n\n  .card-content-full {\n    padding-bottom: 20px;\n  }\n  .collapse-arrow {\n    display: flex;\n    align-items: center;\n    width: 30px;\n    .arrow {\n      background-image: url('../../styles/img/closed-chev-big.svg');\n      width: 24px;\n      height: 24px;\n      position: absolute;\n      transform: rotate(180deg);\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  &.collapsed {\n    .collapsible-heading {\n      .collapse-arrow {\n        .arrow {\n          transform: none;\n        }\n      }\n    }\n\n    .collapsible-content {\n      display:none;\n    }\n  }\n}\n\n.text-align-right {\n  text-align: right;\n}\n\n.pull-left, .pull-right {\n  width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
